export default __webpack_public_path__ + "static/media/icon-edit.291aaff9.svg";